import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { Route } from "react-router-dom";
import moment from "moment";
// import registerServiceWorker from "./registerServiceWorker";
import { unregister } from "./registerServiceWorker";
import "./index.css";
import "moment/locale/sv";

import createStore, { history } from "./store";
import App from "./App";


// Unregister service worker (if already initiated)
unregister();

moment.locale("sv");

const AppWithRedux = (
    <Provider store={ createStore() }>
        <ConnectedRouter history={ history }>
            <Route path="/" component={ App } />
        </ConnectedRouter>
    </Provider>
);

ReactDOM.render(AppWithRedux, document.getElementById("root"));
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js